import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import CommonTable, { ITableColumn } from '@/components/common/CommonTable';
import FilterComponent from '@/components/common/FilterComponent';
import MainHeading from '@/components/common/MainHeading';
import Layout from '@/components/Layout/Layout';
import useFilter from '@/hooks/useFilter';
import {
  IAttendancePagination,
  IDailyTeamResponse,
  IDeptResponse,
  IGetLeaveCountData,
  IPageState,
  ITeamAttendanceState,
  ITeamTableData,
  TDeptDesignationResponse,
} from '@/interfaces/attendance.model';
import { IDeleteResponse, IFilterSideBarForm } from '@/interfaces/common.model';
import { RootState } from '@/redux/store';
import ExportDataHandler, { calculateHours } from '@/utility/CommonFunctions';
import {
  attendanceStatus,
  getFilterUrl,
  showToastNotification,
} from '@/utility/helper';
import moment from 'moment';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { IGetLeaveCountResponse } from '../Leave/MyLeave';
import { useNavigate } from 'react-router-dom';
import { RoutesLink } from '@/utility/RouteLinks';
import { useDispatch } from 'react-redux';
import { setUpdateFilterStates } from '@/redux/features/UserSlice';
import CardLayout from '@/components/Layout/CardLayout';
import ViewIcon from '@/components/Icons/ViewIcon';
interface ISubmitData {
  userId: string;
  markingAttendance?: boolean;
  status?: number;
  date?: string;
  attendanceId?: string;
  checkInTime?: string;
  checkOutTime?: string;
  isHoliday?: boolean;
}
const TeamAttendance = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableView = useSelector((state: RootState) => state?.user?.tableView);
  const filterDetails = useSelector(
    (state: RootState) => state?.user?.filtersStates,
  );
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const [state, setState] = useState<ITeamAttendanceState>({
    attendanceList: [],
    // listType: '',
    // userName: '',
    // userId: '',
  });
  const timeoutRefs = useRef<Map<string, NodeJS.Timeout>>(new Map());
  const [pageStates, setPageStates] = useState<IPageState>({
    departmentList: [],
    designationList: [],
    listType: [],
    userName: '',
    userId: '',
    sortBySingleDate: [
      moment().format('YYYY-MM-DD'),
      moment().format('YYYY-MM-DD'),
    ],
    tableLoader: false,
  });
  const [pagination, setPagination] = useState<IAttendancePagination>({
    currentPage: 1,
    count: 0,
    totalPages: 0,
    searchQuery: '',
  });

  const tableHeading: ITableColumn<ITeamTableData>[] = [
    { value: 'sno', label: 'S.No' },
    { value: 'empNameWithImage', label: 'Employee' },
    { value: 'employeeCode', label: 'Emp. Code' },
    { value: 'department', label: 'Department' },
    { value: 'role', label: 'Designation' },
    { value: 'attendanceStatusToggle', label: 'Status' },
    { value: 'checkIn', label: 'Check In' },
    { value: 'checkOut', label: 'Check Out' },
    { value: 'totalDuration', label: 'Total Duration' },
    { value: 'attendanceType', label: 'Attendance Type' },
    { value: 'shiftTime', label: 'Shift' },
    // { value: 'onRollCompany', label: 'On Roll Company' },
    { value: 'officeName', label: 'Office' },
  ];

  const getAttendance = useCallback(async () => {
    try {
      const filter = {
        myAttendance: false,
        from: 'todayAtt',
        pageNumber: pagination?.currentPage,
        pageSize: filterDetails?.pageSize,
        startDate: pageStates?.sortBySingleDate[0],
        endDate: pageStates?.sortBySingleDate[0],
        // type: 0,
        attendanceType: filterDetails?.attendanceType,
        status: filterDetails?.attendanceStatus,
        departmentId: filterDetails?.department,
        designationId: filterDetails?.designation,
        search: pagination.searchQuery,
      };

      const API =
        API_URL + API_ENDPOINT?.getAttendance + '?' + getFilterUrl(filter);
      setPageStates((pre) => ({
        ...pre,
        tableLoader: true,
      }));
      const response: IDailyTeamResponse = await callApi(API, {
        method: 'GET',
      });
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (response?.status) {
        const newData: ITeamTableData[] = response?.data?.attendance?.map(
          (item, index) => {
            const firstAttendance = item.attendances?.[0];
            return {
              ...item,
              sno: index + 1,
              id: item.id,
              employeeCode: item.employeeCode,
              empNameWithImage: item?.name + '##' + item?.profilePhoto,
              attendanceDate: moment(firstAttendance?.checkInTime).format(
                'DD/MM/YYYY',
              ),
              shiftTime: item?.Shift?.shiftName,
              department: item?.department?.name ?? '',
              onRollCompany: item?.Company?.name ?? '',
              officeName: item?.site?.name,
              siteCheckIn: item?.Shift?.startTime,
              siteCheckOut: item?.Shift?.endTime,
              siteName: item?.usersites?.site?.name,
              attendanceType: firstAttendance?.isODrequest
                ? 'WFH Request'
                : firstAttendance?.isARrequest
                  ? 'AR Request'
                  : firstAttendance?.status === 3
                    ? 'Leave'
                    : 'General',
              attendanceStatusToggle: firstAttendance
                ? firstAttendance?.status
                : 2,
              isHoliday: firstAttendance?.isHoliday,
              checkIn:
                firstAttendance?.checkInTime &&
                moment.utc(firstAttendance?.checkInTime).format('HH:mm'),
              checkOut:
                firstAttendance?.checkOutTime &&
                moment.utc(firstAttendance?.checkOutTime).format('HH:mm'),
              totalDuration:
                firstAttendance?.checkOutTime ||
                (firstAttendance?.checkInTime &&
                  !moment
                    .utc(firstAttendance?.checkInTime)
                    .isBefore(moment(), 'day'))
                  ? calculateHours(
                      firstAttendance?.checkInTime,
                      firstAttendance?.checkOutTime,
                    )
                  : firstAttendance?.checkInTime
                    ? '00:00'
                    : '--',
              role: item?.designation?.name,
              isCheckInDisabled: item?.Shift?.startTime
                ? moment().isBefore(moment(item?.Shift?.startTime, 'HH:mm:ss'))
                : false,
            };
          },
        );
        setState((pre) => ({
          ...pre,
          attendanceList: newData,
        }));
        setPagination((pre) => ({
          ...pre,
          count: response?.data?.pageInfo?.total ?? 0,
          totalPages: response?.data?.pageInfo?.totalPages,
        }));
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
    }
  }, [
    pagination?.currentPage,
    pagination.searchQuery,
    filterDetails?.pageSize,
    filterDetails?.attendanceType,
    filterDetails?.attendanceStatus,
    filterDetails?.department,
    filterDetails?.designation,
    pageStates?.sortBySingleDate,
  ]);

  const getDepartmentAndDesignation = useCallback(async (id: string) => {
    const url = API_URL + API_ENDPOINT.getDesigantion + `?departmentId=${id}`;
    const res: TDeptDesignationResponse = await callApi(url, { method: 'GET' });
    if (res?.status === true) {
      const data = res.data;
      if ('designation' in data) {
        setPageStates((pre) => ({
          ...pre,
          designationList: data.designation,
        }));
      }
    }
  }, []);

  const loadDepartmentAndDesignation = useCallback(async () => {
    const deptRes: IDeptResponse = await callApi(
      API_URL + API_ENDPOINT.getDepartment,
      { method: 'GET' },
    );
    if (deptRes?.status === true) {
      const departments = deptRes.data.department;
      setPageStates((pre) => ({
        ...pre,
        departmentList: departments,
      }));
      const firstDeptId = departments?.[0]?.id;
      if (firstDeptId) {
        getDepartmentAndDesignation(firstDeptId);
      }
    }
  }, [getDepartmentAndDesignation]);

  useEffect(() => {
    getAttendance();
  }, [getAttendance]);

  useEffect(() => {
    loadDepartmentAndDesignation();
  }, [loadDepartmentAndDesignation]);

  const getLeaveCount = async (data: IGetLeaveCountData) => {
    try {
      const url =
        API_URL +
        API_ENDPOINT?.getLeaveCount +
        `?type=${data?.type}&userId=${data?.userId}`;
      const res: IGetLeaveCountResponse = await callApi(url, {
        method: 'GET',
      });
      if (res?.status === true) {
        setPageStates((pre) => ({
          ...pre,
          listType: res?.data,
          userName: data?.userName,
          userId: data?.userId,
        }));
      } else {
        showToastNotification('danger', res?.message);
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    }
  };

  const handleChangeAttendance = async (
    newStatus: number,
    userId: string,
    userName: string,
    checkInTime?: string,
    checkOutTime?: string,
    attendanceId?: string,
    checkInOut = false,
  ) => {
    const attendance = state.attendanceList.find((item) => item.id === userId);
    const attId = attendance?.attendances?.[0]?.id as string;
    if (newStatus !== 3) {
      const selectedDate = pageStates?.sortBySingleDate[0];
      const submitData: ISubmitData = {
        userId: userId,
        attendanceId: attendanceId || attId,
      };
      if (!checkInOut) {
        submitData.status = newStatus;
        submitData.markingAttendance = true;
        submitData.date = selectedDate;
      }
      if (checkInTime) {
        submitData.checkInTime = `${selectedDate}T${checkInTime}:00.000Z`;
      }
      if (checkOutTime) {
        submitData.checkOutTime = `${selectedDate}T${checkOutTime}:00.000Z`;
      }
      const API = `${API_URL}${API_ENDPOINT?.markAttendance}`;
      try {
        const response: IDeleteResponse = await callApi(API, {
          method: 'POST',
          data: submitData,
        });
        if (response?.status === true) {
          showToastNotification('success', response?.message);
          getAttendance();
        } else {
          showToastNotification('danger', response?.message);
        }
      } catch (error) {
        if (error && typeof error === 'object' && 'message' in error) {
          showToastNotification('danger', (error as IApiErrorResponse).message);
        } else {
          showToastNotification('danger', 'Something went wrong');
        }
      }
    } else {
      const data = {
        userName: userName,
        userId: userId,
        type: 'remaining',
      };
      getLeaveCount(data);
      navigate(RoutesLink.addLeave, {
        state: {
          userId: data.userId,
          userName: data.userName,
          type: data.type,
          sortBySingleDate: pageStates.sortBySingleDate,
          markAttendance: true,
          source: 'teamAttendance',
        },
      });

      toggleModal();
      // printData(newStatus);
    }
  };

  const { handleSearchChange, handleChangePageSize, pageChangeHandler } =
    useFilter(pagination, setPagination);

  const singleDateChangeHandler = (date: Date | null) => {
    let formattedDate = null;

    if (date) {
      formattedDate = new Date(
        date.getTime() - date.getTimezoneOffset() * 60000,
      )
        .toISOString()
        .slice(0, 10);
    }

    setPageStates((prevState) => ({
      ...prevState,
      sortBySingleDate: formattedDate
        ? [moment(formattedDate).format('YYYY-MM-DD')]
        : [],
    }));
  };

  const handleData = (
    data: Partial<IFilterSideBarForm> | null,
    type?: string | null,
  ) => {
    if (data?.department && type) {
      getDepartmentAndDesignation(String(data.department));
    }
    if (type == null) {
      setPagination((prev) => ({
        ...prev,
        currentPage: 1,
      }));
      dispatch(
        setUpdateFilterStates({
          attendanceStatus: String(data?.attendanceStatus ?? ''),
          attendanceType: String(data?.attendanceType ?? ''),
          department: String(data?.department ?? ''),
          designation: String(data?.designation ?? ''),
        }),
      );
    }
  };

  const attendanceSortList = {
    department: pageStates?.departmentList,
    designation: pageStates?.designationList,
    attendanceStatus: attendanceStatus,
    attendanceType: [
      // { value: '', label: 'Select Attendance Type' },
      { value: 'general', label: 'General' },
      { value: 'arRequest', label: 'AR Request' },
      { value: 'odRequest', label: 'WFH Request' },
      { value: 'leave', label: 'Leave' },
    ],
  };
  const handleChangeAttendanceTime = async (
    id: string,
    time: string,
    field: string,
  ) => {
    const attendance = state.attendanceList.find((item) => item.id === id);
    if (!attendance) return;
    let newCheckIn = attendance.checkIn;
    let newCheckOut = attendance.checkOut;

    if (field === 'checkIn') newCheckIn = time;
    if (field === 'checkOut') newCheckOut = time;
    setState((prev) => ({
      ...prev,
      attendanceList: prev.attendanceList.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            [field]: time,
          };
        }
        return item;
      }),
    }));
    if (timeoutRefs.current.has(id)) {
      clearTimeout(timeoutRefs.current.get(id)!);
    }
    const attendanceId = attendance?.attendances?.[0]?.id as string;
    const timeoutId = setTimeout(async () => {
      await handleChangeAttendance(
        Number(attendance.attendanceStatusToggle),
        id,
        attendance.empNameWithImage
          ? attendance.empNameWithImage.split('##')[0]
          : '',
        newCheckIn,
        newCheckOut,
        attendanceId,
        true,
      );
      timeoutRefs.current.delete(id);
    }, 1000);

    timeoutRefs.current.set(id, timeoutId);
  };
  const handleExport = () => {
    const data = {
      userType: 0,
      exportDataType: 'dailyAttendance',
      startDate: pageStates?.sortBySingleDate?.[0],
      endDate: pageStates?.sortBySingleDate?.[1],
      department: filterDetails?.department,
      designation: filterDetails?.designation,
    };
    ExportDataHandler(data);
  };
  const actionData = [
    {
      label: 'View',
      className: 'btn btn-link',
      icon: <ViewIcon />,
      title: 'view',
      clickHandler: (data: ITeamTableData) =>
        navigate(`${RoutesLink?.attendanceLogs}`, { state: data }),
    },
  ];
  return (
    <Layout>
      <div className="content">
        <MainHeading
          title={'Team Attendance'}
          pageState={{
            sortBySingleDate: pageStates?.sortBySingleDate,
          }}
          showDefaultDate={true}
          singleDateChangeHandler={singleDateChangeHandler}
        />
        {/* <div className="card mb-4">
          <div className="card-body"> */}
        <CardLayout isGrid={tableView === 'grid'}>
          <FilterComponent
            searchPlaceHolder="Search"
            handleExport={
              state?.attendanceList.length > 0 ? handleExport : null
            }
            handleSearch={handleSearchChange}
            filterArray={{
              isShow: true,
              sortList: attendanceSortList,
            }}
            isGrid={false}
            sortHandler={handleData}
            attendanceSortList={attendanceSortList}
          />
          <CommonTable<ITeamTableData>
            tableHeading={tableHeading}
            ActionData={actionData}
            tableData={state?.attendanceList}
            pageSize={filterDetails?.pageSize}
            currentPage={pagination?.currentPage}
            totalPages={pagination?.totalPages}
            isLoading={pageStates?.tableLoader}
            count={pagination?.count}
            pageChangeHandler={pageChangeHandler}
            handleChangePageSize={handleChangePageSize}
            handleChangeAttendance={handleChangeAttendance}
            handleChangeTime={handleChangeAttendanceTime}
          />
        </CardLayout>
      </div>
    </Layout>
  );
};

export default TeamAttendance;
